<template>
	<div>
		<!-- begin page-header -->
		<h1 class="page-header">Trapezoidal <small>fuzzy membership function</small></h1>
		<!-- end page-header -->
		
		
		<!-- begin row -->
		<div class="row">
			<!-- begin col-6 -->
			<div class="col-lg-12">
				<!-- begin panel -->
				<panel title="Triangular fuzzy membership function">
					<div class="height-sm">
						<vn-line :model="stackedAreaChart.data" id="lineChart2"
							x-format=",.1f"
							y-format=",.4f"
							:clipEdge="stackedAreaChart.clipEdge"
							>
						</vn-line>
				
					</div>
				</panel>
				<!-- end panel -->
			</div>
			
			
			<!-- end col-6 -->		
		</div>
		<!-- end row -->
	</div>

</template>

<script>
export default {
  data() {
    var trapezoidMF = [];
    var a = 40;
    var b = 55;
    var c = 65;
		var d = 70;
		var mu = 0;
    for (var i = 0; i < 80; i++) {
      if (i <= a) {
        mu = 0;
      }
      if (a <= i && i <= b) {
        mu = (i - a) / (b - a);
      }
      if (b <= i && i <= c) {
        mu = 1;
      }
      if (c <= i && i <= d) {
        mu = (d - i) / (d - c);
      }
      if (d <= i) {
        mu = 0;
      }
      trapezoidMF.push({ x: i, y: mu });
    }

    var trapezoidMF2 = [];
    a = 0;
    b = 10;
    c = 20;
    d = 25;
    for ( i = 0; i < 80; i++) {
       mu = 0;

      if (i <= a) {
        mu = 0;
      }
      if (a <= i && i <= b) {
        mu = (i - a) / (b - a);
      }
      if (b <= i && i <= c) {
        mu = 1;
      }
      if (c <= i && i <= d) {
        mu = (d - i) / (d - c);
      }
      if (d <= i) {
        mu = 0;
      }
      trapezoidMF2.push({ x: i, y: mu });
    }

    var trapezoidMF3 = [];
    a = 20;
    b = 35;
    c = 45;
    d = 50;
    for ( i = 0; i < 80; i++) {
       mu = 0;

      if (i <= a) {
        mu = 0;
      }
      if (a <= i && i <= b) {
        mu = (i - a) / (b - a);
      }
      if (b <= i && i <= c) {
        mu = 1;
      }
      if (c <= i && i <= d) {
        mu = (d - i) / (d - c);
      }
      if (d <= i) {
        mu = 0;
      }
      trapezoidMF3.push({ x: i, y: mu });
    }
    var lineChartData = [
      { values: trapezoidMF, key: "tr1", color: "#00ACAC" },
      { values: trapezoidMF2, key: "tr2", color: "#ffACAC" },
      { values: trapezoidMF3, key: "tr3", color: "#00ffAC" }
    ];
    return {
      stackedAreaChart: {
        data: lineChartData
      }
    };
  },

  methods: {
    funkcia() {
      alert("Hodnota: ");
    }
  }
};
</script>